import React from 'react';
import { Link } from 'react-router-dom';
import { FaGraduationCap, FaDownload } from 'react-icons/fa';

const AboutPage = () => (
  <div style={{ background: '#071325', minHeight: '100vh', color: '#ffffff', padding: '60px 24px' }}>
    <div style={{ maxWidth: '1100px', margin: '0 auto' }}>

      {/* Header */}
      <div style={{ textAlign: 'center', marginBottom: '50px' }}>
        <span className="badge badge-gold" style={{ marginBottom: '12px' }}>
          👨‍💻 Professional Background
        </span>
        <h1 style={{ fontSize: '2.5rem', color: '#ffffff', margin: '8px 0' }}>
          About Adedeji Babalola
        </h1>
        <p style={{ color: '#94a3b8', maxWidth: '680px', margin: '0 auto', fontSize: '1.05rem' }}>
          Software Engineer | Cloud &amp; Network | Data Analyst.
        </p>
      </div>

      {/* Bio Grid */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
        gap: '40px',
        alignItems: 'center',
        marginBottom: '70px'
      }}>
        {/* Profile Image & Quick Facts */}
        <div className="glass-card" style={{ padding: '32px', textAlign: 'center' }}>
          <img
            src="/dejicvuse.png"
            alt="Adedeji Babalola"
            style={{
              width: '180px',
              height: '180px',
              borderRadius: '50%',
              objectFit: 'cover',
              border: '4px solid #45aaf2',
              boxShadow: '0 8px 25px rgba(69, 170, 242, 0.4)',
              marginBottom: '20px'
            }}
          />
          <h2 style={{ fontSize: '1.6rem', color: '#ffffff', margin: '0 0 6px 0' }}>Adedeji Babalola</h2>
          <p style={{ color: '#45aaf2', fontWeight: '600', margin: '0 0 16px 0', fontSize: '0.95rem' }}>
            Software, Cloud, Data &amp; Network Engineer
          </p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', fontSize: '0.9rem', color: '#94a3b8', textAlign: 'left', background: 'rgba(7,19,37,0.6)', padding: '16px', borderRadius: '12px' }}>
            <div>📍 <strong>Location:</strong> Helsinki</div>
            <div>📧 <strong>Email:</strong> daygme@gmail.com</div>
            <div>🗣️ <strong>Languages:</strong> English (Full Prof) | Finnish (Working)</div>
            <div>💼 <strong>Status:</strong> Available for Full-Time, Part-Time &amp; Contracts</div>
          </div>
        </div>

        {/* Narrative Bio */}
        <div>
          <h3 style={{ fontSize: '1.8rem', color: '#ffffff', marginBottom: '16px' }}>
            Combining Academic Rigor with Multi-Domain Tech Execution
          </h3>
          <p style={{ color: '#cbd5e1', fontSize: '1.05rem', lineHeight: '1.7', marginBottom: '16px' }}>
            Hello! I am <strong>Adedeji</strong>, an accomplished technology specialist fueled by a passion for building robust digital infrastructure, writing clean software, and solving real-world business problems.
          </p>
          <p style={{ color: '#cbd5e1', fontSize: '1rem', lineHeight: '1.7', marginBottom: '16px' }}>
            My technical focus spans the complete digital lifecycle: architecting scalable multi-cloud platforms on <strong>AWS &amp; Azure</strong>, developing modern full-stack web applications with <strong>React &amp; Node.js</strong>, configuring secure enterprise networks with <strong>Cisco CCNA/CyberOps</strong> tools, and analyzing complex datasets using <strong>Python, SQL &amp; SPSS</strong>.
          </p>
          <p style={{ color: '#cbd5e1', fontSize: '1rem', lineHeight: '1.7', marginBottom: '24px' }}>
            With a background as an entrepreneur and IT support specialist, I bring strong project management, SLA discipline, customer care, and business acumen to every role or contract engagement.
          </p>

          <div style={{ display: 'flex', gap: '14px', flexWrap: 'wrap' }}>
            <Link to="/cv" className="btn-primary">
              <FaDownload /> View Complete Resume
            </Link>
            <Link to="/contact" className="btn-secondary">
              Get in Touch
            </Link>
          </div>
        </div>
      </div>

      {/* ACADEMIC TRIO SECTION */}
      <div style={{ marginBottom: '70px' }}>
        <div style={{ textAlign: 'center', marginBottom: '36px' }}>
          <span className="badge badge-gold">Educational Foundation</span>
          <h2 style={{ fontSize: '2.2rem', color: '#ffffff', marginTop: '10px' }}>
            Academic Degrees Across Tech &amp; Systems
          </h2>
          <p style={{ color: '#94a3b8', fontSize: '0.95rem' }}>
            A powerful combination of fundamental analytical science, modern ICT engineering, and high-level circular economy systems.
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '24px'
        }}>
          {/* Degree 1 */}
          <div className="glass-card" style={{ padding: '28px', borderTop: '4px solid #45aaf2' }}>
            <div style={{ color: '#45aaf2', fontSize: '2rem', marginBottom: '12px' }}><FaGraduationCap /></div>
            <h3 style={{ fontSize: '1.25rem', color: '#ffffff', marginBottom: '6px' }}>B.Sc. Information Technology</h3>
            <p style={{ color: '#45aaf2', fontWeight: '600', fontSize: '0.9rem', marginBottom: '10px' }}>
              Metropolia University of Applied Sciences, Helsinki, Finland (June 2026)
            </p>
            <p style={{ color: '#94a3b8', fontSize: '0.9rem', lineHeight: '1.6' }}>
              Majoring in <strong>Smart IoT Systems</strong>. Core focus on device configuration, networking protocols, Linux administration, cloud computing, and web application engineering.
            </p>
          </div>

          {/* Degree 2 */}
          <div className="glass-card" style={{ padding: '28px', borderTop: '4px solid #00d2d3' }}>
            <div style={{ color: '#00d2d3', fontSize: '2rem', marginBottom: '12px' }}><FaGraduationCap /></div>
            <h3 style={{ fontSize: '1.25rem', color: '#ffffff', marginBottom: '6px' }}>M.Sc. Circular Economy</h3>
            <p style={{ color: '#00d2d3', fontWeight: '600', fontSize: '0.9rem', marginBottom: '10px' }}>
              Lappeenranta-Lahti University of Technology (LUT), Finland (July 2023)
            </p>
            <p style={{ color: '#94a3b8', fontSize: '0.9rem', lineHeight: '1.6' }}>
              Master’s thesis &amp; coursework centered on systems modeling, data-driven resource optimization, sustainability analytics, and operational lifecycle efficiency.
            </p>
          </div>

          {/* Degree 3 */}
          <div className="glass-card" style={{ padding: '28px', borderTop: '4px solid #f8d210' }}>
            <div style={{ color: '#f8d210', fontSize: '2rem', marginBottom: '12px' }}><FaGraduationCap /></div>
            <h3 style={{ fontSize: '1.25rem', color: '#ffffff', marginBottom: '6px' }}>B.Sc. Physics</h3>
            <p style={{ color: '#f8d210', fontWeight: '600', fontSize: '0.9rem', marginBottom: '10px' }}>
              University of Ibadan, Ibadan, Nigeria (Nov 2012)
            </p>
            <p style={{ color: '#94a3b8', fontSize: '0.9rem', lineHeight: '1.6' }}>
              Foundational degree in applied mathematics, quantitative problem solving, physical optics, electronics, and analytical scientific methodology.
            </p>
          </div>
        </div>
      </div>

      {/* LAB & CREATIVE GALLERY */}
      <div className="glass-card" style={{ padding: '40px 32px', textAlign: 'center' }}>
        <h3 style={{ fontSize: '1.8rem', color: '#ffffff', marginBottom: '12px' }}>
          Hands-On Engineering &amp; IoT Lab
        </h3>
        <p style={{ color: '#94a3b8', fontSize: '0.95rem', maxWidth: '600px', margin: '0 auto 28px auto' }}>
          Combining hardware experimentation, network setup, and digital content creation.
        </p>

        <div style={{
          display: 'flex',
          justify: 'center',
          flexWrap: 'wrap',
          gap: '20px'
        }}>
          <div style={{ width: '220px', height: '220px', borderRadius: '16px', overflow: 'hidden', border: '1px solid rgba(255,255,255,0.15)' }}>
            <img src="/AdedejiwebuseX21n.png" alt="Adedeji Tech Lab 1" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          </div>
          <div style={{ width: '220px', height: '220px', borderRadius: '16px', overflow: 'hidden', border: '1px solid rgba(255,255,255,0.15)' }}>
            <img src="/AdedejiwebuseX21o.png" alt="Adedeji Tech Lab 2" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          </div>
          <div style={{ width: '220px', height: '220px', borderRadius: '16px', overflow: 'hidden', border: '1px solid rgba(255,255,255,0.15)' }}>
            <img src="/adedejiiotlab.jpg" alt="Adedeji IoT Lab Setup" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          </div>
        </div>
      </div>

    </div>
  </div>
);

export default AboutPage;
